import { render, staticRenderFns } from "./DistractorSearch.vue?vue&type=template&id=aed2e82c&scoped=true"
import script from "./DistractorSearch.vue?vue&type=script&lang=js"
export * from "./DistractorSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed2e82c",
  null
  
)

export default component.exports